import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"

/**
 * GET MEDIA REUSE STATS
 * /api/v1/media/clients/{clientId}/reuse-stats (relative path, no leading slash)
 */
export const fetchMediaReuseStats = createAsyncThunk(
  "mediaReuseStats/fetchMediaReuseStats",
  async ({ clientId }, { rejectWithValue }) => {
    try {
      const response = await get(`media/clients/${clientId}/reuse-stats`)
      return { response, clientId: String(clientId) }
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch media stats"
      )
    }
  },
  {
    condition: ({ clientId, force } = {}, { getState }) => {
      if (force) return true
      if (clientId == null || clientId === "") return false
      const slice = getState().mediaReuseStats ?? {}
      const same = String(slice.fetchedForClientId ?? "") === String(clientId)
      if (slice.status === "loading" && same) return false
      if (slice.status === "succeeded" && same) return false
      return true
    },
  },
)

const mediaReuseStatsSlice = createSlice({
  name: "mediaReuseStats",
  initialState: {
    reusedAssetsPercent: 0,
    topAssets: 0,
    status: "idle",
    error: null,
    fetchedForClientId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMediaReuseStats.pending, (state, action) => {
        state.status = "loading"
        state.error = null
        const nextId = action.meta?.arg?.clientId
        if (nextId != null) state.fetchedForClientId = String(nextId)
      })
      .addCase(fetchMediaReuseStats.fulfilled, (state, action) => {
        state.status = "succeeded"
        const payload = action.payload?.response ?? action.payload
        state.reusedAssetsPercent = payload?.reusedAssetsPercent
        state.topAssets = payload?.topAssets
        const clientId = action.payload?.clientId ?? action.meta?.arg?.clientId
        if (clientId != null) state.fetchedForClientId = String(clientId)
      })
      .addCase(fetchMediaReuseStats.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export default mediaReuseStatsSlice.reducer
